<span class="copy-field" (click)="copyText($event)">
  <span #copyContent class="copy-content">
    <ng-content></ng-content>
  </span>
  <div class="copy-icon" aria-hidden="true">
    <mat-icon>content_copy</mat-icon>
  </div>
</span>
